import { Accordion, Box, Button, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import { getLinkPropsFromAction } from "~/core/utils/action.utils";
import type { SecondaryFooterProps } from "~/features/secondary-footer/SecondaryFooter";

export const FooterMenu: FC<SecondaryFooterProps> = ({
  data,
  isActionInactive,
  getUrl,
  onCallAction,
}) => {
  const accordions = data.translations?.[0]?.footer_menu?.action_items ?? [];
  return (
    <Flex flexDirection="column" gap={4} width="100%">
      <Accordion>
        {accordions.map((item, i) => {
          if (!item?.menu_action_items_id) {
            return null;
          }
          const isLast = i === accordions.length - 1;

          return (
            <Flex flexDirection="column">
              <Accordion.Item
                key={item.menu_action_items_id.id}
                title={item.menu_action_items_id?.translations?.[0]?.name}
                variant="secondary"
                p={{ py: 0, px: 0 }}
                headingWrapper={(wrapperProps) => (
                  <Flex
                    align="center"
                    justify="space-between"
                    flexDirection="row"
                    minHeight={40}
                    color="primary-default"
                    fontSize="body.mobile.small"
                    lineHeight={"body.mobile.small"}
                    md={{
                      fontSize: "body.desktop.small",
                      lineHeight: "body.desktop.small",
                    }}
                    d={{
                      fontSize: "body.desktop.small",
                      lineHeight: "body.desktop.small",
                    }}
                  >
                    {wrapperProps.children}
                  </Flex>
                )}
              >
                <Flex gap={4} flexDirection="column">
                  {item.menu_action_items_id?.items?.map((elem, index) => {
                    const controlAction =
                      elem?.menu_action_sub_items_id?.action;
                    const {
                      isInactive,
                      href,
                      handlePress: handlePressLink,
                    } = getLinkPropsFromAction({
                      onCallAction,
                      getUrl,
                      controlAction,
                      isActionInactive,
                    });

                    return (
                      !isInactive && (
                        <Flex height={"100%"} maxHeight={32} align={"center"}>
                          <Button
                            onPress={handlePressLink}
                            href={href}
                            key={index}
                            variant={"tertiary"}
                            color="text-secondary-default"
                            fontSize="body.mobile.small"
                            md={{
                              fontSize: "body.desktop.small",
                            }}
                            d={{
                              fontSize: "body.desktop.small",
                            }}
                            fontWeight="mobile.normal"
                            lineHeight="body.mobile.small"
                            p={{ py: 8, px: 0 }}
                          >
                            {
                              elem?.menu_action_sub_items_id?.translations?.[0]
                                ?.name
                            }
                          </Button>
                        </Flex>
                      )
                    );
                  })}
                </Flex>
              </Accordion.Item>
              {!isLast && (
                <Box
                  border={{
                    color: "border-subtle",
                    style: "solid",
                    width: {
                      bottom: "1px",
                    },
                  }}
                />
              )}
            </Flex>
          );
        })}
      </Accordion>
    </Flex>
  );
};
